import { PortableTextBlock } from "../../components/PortableText/PortableText";
import { SanityNode } from "../../config/build/models/node";
import { SanitySlug } from "../../config/build/models/sanitySlug";
import { FileLink } from "../shared/FileLink";
import { LinkInfo } from "../shared/LinkInfo";
import { SanityFormField, SanityFormHiddenValueField } from "./SanityFormField";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FormValues = Record<string, any>;

export type SanityFormProps = {
  _id: string;
  _rawInputs?: SanityFormField[];
  _type: string;
  gtmFormType?: string;
  gtmFormValueFieldName?: string;
  inputs?: SanityFormField[];
  modifyValue?: (formValues: FormValues) => FormValues;
  onSubmitted?: () => void;
  slug: SanitySlug;
  submitCompleteText?: string;
  submitText?: string;
  submittingText?: string;
  title: string;
  fileLinkForDownloadAfterSubmission?: FileLink;
  fileLinkDescription?: string;
  customerType?: string;
  variant?: "default" | "calculation-form" | "modal";
  hiddenValues?: SanityFormHiddenValueField[];
};

export type SanityPriceCalculationFormProps = SanityFormProps & {
  _rawPriceInformation?: PortableTextBlock[];
  basePrice?: number;
  contactButtonLabel?: string;
  contactLink?: LinkInfo;
  currency?: string;
  feedbackForm?: SanityFormProps;
  feedbackLabel?: string;
  phoneNumber?: string;
  priceDisclaimer?: string;
  priceInformation?: PortableTextBlock[];
  priceInformationTitle?: string;
  priceTitle?: string;
  showCurrencyAfterPrice?: boolean;
  showSummary?: boolean;
  summaryTitle?: string;
  thankYouPage?: SanityNode;
  useContactLink?: boolean;
  useThankYouPage?: boolean;
};

export enum SanityFormType {
  StandardForm = "formTemplate",
  PriceForm = "priceCalculatorFormTemplate"
}
